/* Nyhetsbrevsrutan i bloggartiklar (snippets/NV-NEWSLETTER-SIDEBAR.liquid).
   Klaviyo-formulärets id kommer från script-taggens data-form-id. */
(function () {
  const FORM_ID = (document.currentScript && document.currentScript.getAttribute('data-form-id')) || '';
  const DELAY = 30000;
  const DUR = 450;
  const EASE = 'cubic-bezier(.22,.61,.36,1)';
  const STORE_KEY = 'nvNewsletterPopupDone';

  const slot = document.querySelector('.nv-newsletter-slot');
  const widget = document.querySelector('.nv-newsletter-widget');
  const closeBtn = widget && widget.querySelector('.nv-newsletter-close');
  if (!slot || !widget) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const wideScreen = window.matchMedia('(min-width: 1350px)');
  let state = 'inline';

  /* Clarity: stängknappen var ofta sista klicket innan besökaren lämnade.
     Därför minns vi ett stängt fönster i 14 dagar (inte bara besöket),
     och en anmälan för alltid. */
  const HIDE_DAYS = 14;
  const isDone = () => {
    try {
      const v = localStorage.getItem(STORE_KEY);
      if (!v) return false;
      if (v === 'signed') return true;
      return Date.now() - parseInt(v, 10) < HIDE_DAYS * 864e5;
    } catch (e) { return false; }
  };
  const markDone = (signed) => {
    try {
      /* En anmälan gäller för alltid och skrivs aldrig över av en stängning */
      if (localStorage.getItem(STORE_KEY) === 'signed') return;
      localStorage.setItem(STORE_KEY, signed ? 'signed' : String(Date.now()));
    } catch (e) {}
  };

  /* Placering i text eller sidopanel, flyttar hela slotten */
  const placeSlot = () => {
    const rail = document.querySelector('[data-toc-rail]');
    const shouldBeInRail = !!(rail && wideScreen.matches);
    const isInRail = !!(rail && rail.contains(slot));
    if (shouldBeInRail && !isInRail) {
      rail.appendChild(slot);
    } else if (!shouldBeInRail && isInRail) {
      const headings = document.querySelectorAll('.article--content.rte h2');
      const target = headings[3];
      if (target) {
        target.parentNode.insertBefore(slot, target);
      } else {
        const content = document.querySelector('.article--content.rte');
        if (content) content.appendChild(slot);
      }
    }
  };

  const run = (frames) => {
    if (reduceMotion) return Promise.resolve(null);
    const anim = widget.animate(frames, { duration: DUR, easing: EASE, fill: 'forwards' });
    return anim.finished.then(() => anim);
  };

  const OUT_RIGHT = [{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(80px)', opacity: 0 }];
  const IN_RIGHT = [{ transform: 'translateX(80px)', opacity: 0 }, { transform: 'translateX(0)', opacity: 1 }];
  const IN_BOTTOM = [{ transform: 'translateY(calc(100% + 24px))', opacity: 0 }, { transform: 'translateY(0)', opacity: 1 }];
  const OUT_BOTTOM = [{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(calc(100% + 24px))', opacity: 0 }];

  /* Väntar tills Klaviyo har renderat formuläret, max 15 sekunder */
  const waitForForm = () => new Promise((resolve) => {
    const started = Date.now();
    const check = () => {
      if (widget.querySelector('form')) return resolve(true);
      if (Date.now() - started > 15000) return resolve(false);
      setTimeout(check, 200);
    };
    check();
  });

  /* Skriver besökaren i formuläret ska det inte flyttas, då tappar man fokus och text */
  const RETRY = 10000;
  const MAX_RETRIES = 6;
  let retries = 0;
  const isInUse = () => {
    if (widget.contains(document.activeElement)) return true;
    const fields = widget.querySelectorAll('input, textarea, select');
    for (let i = 0; i < fields.length; i++) {
      const f = fields[i];
      const type = (f.getAttribute('type') || '').toLowerCase();
      if (type === 'hidden' || type === 'submit' || type === 'button' || type === 'checkbox' || type === 'radio') continue;
      if (f.value && String(f.value).trim() !== '') return true;
    }
    return false;
  };

  const openPopup = async () => {
    if (state !== 'inline' || isDone()) return;
    const ready = await waitForForm();
    if (!ready || state !== 'inline' || isDone()) return;
    if (isInUse()) {
      /* Försök igen lite senare, eller hoppa över helt om det dröjer */
      if (retries < MAX_RETRIES) {
        retries++;
        setTimeout(openPopup, RETRY);
      }
      return;
    }
    state = 'busy';
    slot.style.height = widget.offsetHeight + 'px';

    const out = await run(OUT_RIGHT);
    widget.classList.add('nv-is-floating');
    /* Som popup är rutan en dialog. Fokus flyttas inte dit, den visas av sig själv. */
    widget.setAttribute('role', 'dialog');
    widget.setAttribute('aria-label', 'Nyhetsbrev');
    document.body.appendChild(widget);
    if (out) out.cancel();

    const inn = await run(IN_BOTTOM);
    if (inn) inn.cancel();
    state = 'floating';
  };

  const closePopup = async () => {
    if (state !== 'floating') return;
    state = 'busy';
    markDone();
    /* Var fokus i rutan läggs det tillbaka i rutan på sin plats i texten */
    const hadFocus = widget.contains(document.activeElement);

    const down = await run(OUT_BOTTOM);
    widget.classList.remove('nv-is-floating');
    widget.removeAttribute('role');
    widget.removeAttribute('aria-label');
    slot.appendChild(widget);
    if (hadFocus) {
      if (!widget.hasAttribute('tabindex')) widget.setAttribute('tabindex', '-1');
      try { widget.focus({ preventScroll: true }); } catch (e) {}
    }
    slot.style.height = '';
    if (down) down.cancel();

    const back = await run(IN_RIGHT);
    if (back) back.cancel();
    state = 'inline';
  };

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  /* Escape stänger bara när man står i rutan, inte när man trycker Escape någon annanstans */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (widget.contains(e.target) || widget.contains(document.activeElement)) closePopup();
  });

  /* Har man anmält sig visas ingen popup igen under besöket */
  window.addEventListener('klaviyoForms', (e) => {
    if (e.detail && e.detail.type === 'submit' && e.detail.formId === FORM_ID) markDone(true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeSlot, { once: true });
  } else {
    placeSlot();
  }
  if (wideScreen.addEventListener) {
    wideScreen.addEventListener('change', placeSlot);
  } else {
    wideScreen.addListener(placeSlot);
  }

  /* Popupen visas bara för den som faktiskt läser: minst DELAY på sidan
     OCH scrollat förbi 60 % av artikeln. Aldrig på mobil och surfplatta
     (under 1000px täcker den texten), och inte om formuläret redan syns
     i texten eller sidopanelen. Formuläret i texten finns alltid kvar. */
  const desktop = window.matchMedia('(min-width: 1000px)');
  const article = document.querySelector('.article--content.rte');
  let timeOk = false;
  let scrollOk = false;
  let triggered = false;

  const inlineVisible = () => {
    const r = slot.getBoundingClientRect();
    return r.height > 0 && r.top < window.innerHeight && r.bottom > 0;
  };

  const tryOpen = () => {
    if (triggered || !timeOk || !scrollOk || !desktop.matches || isDone()) return;
    if (inlineVisible()) return;
    triggered = true;
    window.removeEventListener('scroll', onScroll);
    openPopup();
  };

  const onScroll = () => {
    if (!scrollOk && article) {
      const r = article.getBoundingClientRect();
      const read = (window.innerHeight - r.top) / r.height;
      if (read >= 0.6) scrollOk = true;
    }
    tryOpen();
  };

  if (!isDone() && article) {
    setTimeout(() => { timeOk = true; tryOpen(); }, DELAY);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
